import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

const eClinicTour = driver({
  showProgress: true,
  allowClose: true,
  doneBtnText: 'Listo',
  nextBtnText: 'Siguiente →',
  prevBtnText: '← Anterior',
  overlayOpacity: 0.6,
  stageRadius: 8,
  steps: [
    // ====== INTRO ======
    {
      popover: {
        title: '🏥 Bienvenido a eCliniq',
        description: 'Sistema de gestión clínica para consultorios médicos en República Dominicana. Este recorrido de 4 minutos le mostrará todo lo que puede hacer.',
        side: 'bottom', align: 'start',
      },
    },

    // ====== MÓDULOS CLÍNICOS ======
    {
      element: 'a[href="/patients"]',
      popover: {
        title: '👤 Pacientes',
        description: 'Registre pacientes con cédula dominicana, RNC o pasaporte. Asigne seguros ARS, contactos, alergias, y vea el historial clínico completo.',
        side: 'right', align: 'start',
      },
    },
    {
      element: 'a[href="/appointments"]',
      popover: {
        title: '📅 Citas',
        description: 'Agenda médica con filtros por doctor, estado y fecha. Programe, confirme, reprograme o cancele citas desde una sola pantalla.',
        side: 'right', align: 'start',
      },
    },
    {
      element: 'a[href="/consultations"]',
      popover: {
        title: '🩺 Consultas',
        description: 'El módulo principal. Registre signos vitales, motivo de consulta, diagnóstico CIE-10, examen físico, recetas médicas, órdenes de laboratorio e imágenes.',
        side: 'right', align: 'start',
      },
    },

    // ====== CIRUGÍA ======
    {
      element: 'a[href="/surgery"]',
      popover: {
        title: '🔪 Cirugía',
        description: 'Gestión de procedimientos quirúrgicos con checklists pre-operatorios, consentimientos informados, y recetas post-operatorias automatizadas.',
        side: 'right', align: 'start',
      },
    },
    {
      element: 'a[href="/surgeon-dashboard"]',
      popover: {
        title: '📊 Dashboard de Cirugía',
        description: 'Vista rápida de los procedimientos quirúrgicos pendientes, programados y completados. Ideal para el cirujano.',
        side: 'right', align: 'start',
      },
    },

    // ====== LABORATORIO E IMÁGENES ======
    {
      element: 'a[href="/imaging"]',
      popover: {
        title: '🖼️ Imágenes',
        description: 'Gestión de estudios de imagenología: rayos X, ultrasonidos, tomografías. Suba archivos DICOM, anote resultados y genere reportes.',
        side: 'right', align: 'start',
      },
    },

    // ====== FARMACIA ======
    {
      element: 'a[href="/pharmacy"]',
      popover: {
        title: '💊 Farmacia',
        description: 'Catálogo de medicamentos dominicano con más de 2,200 fármacos. Gestione categorías, unidades, precios por ARS y stock.',
        side: 'right', align: 'start',
      },
    },

    // ====== FACTURACIÓN Y FISCAL ======
    {
      element: 'a[href="/billing"]',
      popover: {
        title: '🧾 Facturación Fiscal NCF',
        description: 'Cree facturas con comprobante fiscal NCF (B01/B02/B14). ITBIS por ítem al 18% o 16%, PDF con QR e-CF, y envío a DGII.',
        side: 'right', align: 'start',
      },
    },

    // ====== SEGUROS ARS ======
    {
      element: 'a[href="/insurance-companies"]',
      popover: {
        title: '🛡️ ARS y Seguros',
        description: 'Gestione las 10 aseguradoras dominicanas (SeNaSa, Humano, Mapfre, Universal...) con sus planes y coberturas. Precios diferenciados por ARS para cada servicio.',
        side: 'right', align: 'start',
      },
    },
    {
      element: 'a[href="/pre-authorizations"]',
      popover: {
        title: '📋 Pre-Autorizaciones',
        description: 'Solicite y registre autorizaciones previas de las ARS para procedimientos, laboratorios, imágenes y medicamentos. Haga seguimiento de pendientes.',
        side: 'right', align: 'start',
      },
    },

    // ====== SERVICIOS ======
    {
      element: 'a[href="/services"]',
      popover: {
        title: '📋 Servicios',
        description: 'Catálogo de servicios médicos con precios. Configure consultas, procedimientos, y otros servicios con precios por ARS y código DGII.',
        side: 'right', align: 'start',
      },
    },

    // ====== DOCTORES ======
    {
      element: 'a[href="/doctors"]',
      popover: {
        title: '👨‍⚕️ Doctores',
        description: 'Registre médicos con su especialidad, exequátur, y RNC profesional para facturación independiente. Cada doctor puede tener su propia marca de clínica.',
        side: 'right', align: 'start',
      },
    },

    // ====== CONFIGURACIÓN ======
    {
      element: 'a[href="/clinic-settings"]',
      popover: {
        title: '🏢 Mi Clínica',
        description: 'Personalice su consultorio: nombre, logo, RNC, autorización DGII, certificado digital .p12 para e-CF, y establecimiento fiscal.',
        side: 'right', align: 'start',
      },
    },
    {
      element: 'a[href="/ncf-sequences"]',
      popover: {
        title: '🔢 Secuencias NCF',
        description: 'Gestione los rangos autorizados por DGII. Vea cuántos NCF disponibles quedan, alertas de agotamiento y fechas de vencimiento.',
        side: 'right', align: 'start',
      },
    },
    {
      element: 'a[href="/suppliers"]',
      popover: {
        title: '🚚 Proveedores',
        description: 'Registre sus proveedores con RNC para el reporte DGII 606 de compras. Ingrese facturas de compra con NCF del suplidor.',
        side: 'right', align: 'start',
      },
    },

    // ====== REPORTES ======
    {
      element: 'a[href="/reports"]',
      popover: {
        title: '📈 Reportes',
        description: 'Dashboard de KPIs, reportes clínicos (consultas, admisiones, pacientes) y reportes financieros. Incluye DGII 607 (ventas) y 606 (compras) descargables.',
        side: 'right', align: 'start',
      },
    },

    // ====== ADMINISTRACIÓN ======
    {
      element: 'a[href="/settings-management"]',
      popover: {
        title: '⚙️ Configuración del Sistema',
        description: 'Administre perfiles de usuario, módulos habilitados por rol, y configuraciones globales del sistema.',
        side: 'right', align: 'start',
      },
    },

    // ====== CIERRE ======
    {
      popover: {
        title: '✅ ¡Listo!',
        description: 'eCliniq cubre todo el flujo de un consultorio dominicano: pacientes, citas, consultas, cirugía, laboratorio, farmacia, ARS, facturación fiscal NCF, reportes DGII, e-CF, y más.<br><br>Use el botón <b>?</b> abajo a la derecha para repetir este recorrido cuando quiera.',
      },
    },
  ],
});

export function startTour() {
  eClinicTour.drive();
}

export default eClinicTour;
